<template>
  <div>
    <PaymentDetailsTypeFGTS v-if="isReceiptType('CustomReceiptFGTS')" :paymentDetail="paymentDetail" />
    <PaymentDetailsTypeRFB v-else-if="isReceiptType('CustomReceiptRFB')" :paymentDetail="paymentDetail" />
    <PaymentDetailsTypeSEFAZ v-else-if="isReceiptType('CustomReceiptSEFAZ')" :paymentDetail="paymentDetail" />
    <PaymentDetailsTypeConcessionaria v-else-if="isReceiptType('ReceiptUtilities')" :paymentDetail="paymentDetail" />
    <PaymentDetailsTypeRendimento v-else-if="isReceiptType('ReceiptRendimento')" :paymentDetail="paymentDetail" />
    <PaymentDetailsTypeBoleto v-else-if="isReceiptType('ReceiptBill')" :paymentDetail="paymentDetail" />
    <div v-else>
      <p>Falha ao recuperar comprovante de pagamento.</p>
    </div>
  </div>
</template>

<script>
import paymentDetailsCommonMethods from './paymentDetailsCommonMethods.js';

import PaymentDetailsTypeConcessionaria from './PaymentDetailsTypeConcessionaria.vue';
import PaymentDetailsTypeFGTS from './PaymentDetailsTypeFGTS.vue';
import PaymentDetailsTypeRFB from './PaymentDetailsTypeRFB.vue';
import PaymentDetailsTypeSEFAZ from './PaymentDetailsTypeSEFAZ.vue';
import PaymentDetailsTypeRendimento from './PaymentDetailsTypeRendimento.vue';
import PaymentDetailsTypeBoleto from './PaymentDetailsTypeBoleto.vue';

export default {
  name: 'AppPaymentDetailsTypeSwitch',
  mixins: [paymentDetailsCommonMethods],
  props: {
    paymentDetail: {
      type: Object,
      required: true,
    },
  },
  components: {
    PaymentDetailsTypeConcessionaria,
    PaymentDetailsTypeFGTS,
    PaymentDetailsTypeRFB,
    PaymentDetailsTypeSEFAZ,
    PaymentDetailsTypeRendimento,
    PaymentDetailsTypeBoleto,
  },
};
</script>
